import React from 'react'
import './UnleashPotential.css'
import BlueButton3 from './BlueButton3'
import FiveStars from '../images/svg/5stars.svg'


function UnleashPotential() {
  return (
    <div className='unleash-potential-main'>
      <h3>Build systems.<br />
        Scale without limits.</h3>
      <div className='button-div'>
        <BlueButton3
          text="Let's Talk"
        />
      </div>
      <p>Join brands that replaced manual marketing with intelligent growth engines.</p>
      <div className='stars-section'>
        <div className='col-one'>
          <img src={FiveStars} alt='Five Stars' />
          <p>
            "After implementing AI automation, our team<br /> reduced manual marketing tasks by over<br /> 60% while increasing output"
          </p>
        </div>
        <div className='col-two'>
          <img src={FiveStars} alt='Five Stars' />
          <p>
            "AI-driven optimization improved our conversion<br /> rate by 28% within the first quarter."
          </p>


        </div>
        <div className='col-three'>
          <img src={FiveStars} alt='Five Stars' />
          <p>
            "The system works 24/7. Leads are qualified<br /> automatically, and our sales team only speaks<br /> with high-intent prospects."
          </p>


        </div>
      </div>
    </div>
  )
}

export default UnleashPotential